var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',{staticClass:"flex"},[_c('div',{staticClass:"fit row wrap wrapper"},[_c('div',{staticClass:"col-12"},[_vm._v(" Landing Page ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }